const Maximize = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 38.378 38.378"
  >
    <g id="drawing_10884299" transform="translate(-156 -104)">
      <g id="Icon" transform="translate(156 104)">
        <path
          id="Path_641"
          data-name="Path 641"
          d="M192.983,107.6a3.6,3.6,0,0,0-3.6-3.6H166.6a3.6,3.6,0,0,0-3.6,3.6v22.787a3.6,3.6,0,0,0,3.6,3.6h22.787a3.6,3.6,0,0,0,3.6-3.6Zm-9.591,4.8.239.024.218.068a1.2,1.2,0,0,1,.646.646l0,0a1.2,1.2,0,0,1,.09.457v9.594a1.2,1.2,0,1,1-2.4,0v-6.7l-8.747,8.747a1.2,1.2,0,0,1-1.7-1.7l8.747-8.747h-6.7a1.2,1.2,0,1,1,0-2.4Z"
          transform="translate(-154.605 -104)"
          fill="inherit"
          fill-rule="evenodd"
        />
        <path
          id="Path_642"
          data-name="Path 642"
          d="M166.794,112.2a1.2,1.2,0,0,0-1.2-1.2h-6a3.6,3.6,0,0,0-3.6,3.6v22.787a3.6,3.6,0,0,0,3.6,3.6h22.787a3.6,3.6,0,0,0,3.6-3.6v-6a1.2,1.2,0,0,0-1.2-1.2h-16.79a1.2,1.2,0,0,1-1.2-1.2Zm-2.4,1.2h-4.8a1.2,1.2,0,0,0-1.2,1.2v22.787a1.2,1.2,0,0,0,1.2,1.2h22.787a1.2,1.2,0,0,0,1.2-1.2v-4.8H167.993a3.6,3.6,0,0,1-3.6-3.6Z"
          transform="translate(-156 -102.605)"
          fill="inherit"
          fill-rule="evenodd"
        />
      </g>
    </g>
  </svg>
);

export default Maximize;
